import React, { useState, FC } from 'react'
import * as yup from 'yup'
import moment from 'moment-timezone'

import { EventWrapper } from 'components/Calendar/style'

import tackleIcon from 'assets/images/tackleIcon.png'
import Button from 'components/Common/Button'

// calender event schema for edit
export const eventEditSchema = yup.object({
  description: yup.string().required('Please enter description'),
})
interface IUpcomingMeetingCard {
  status?: string
  event?: any
  timeMin?: any
  timeMax?: any
  calendarName?: string
  cancelMeetingLoading?: boolean
  cancelUserCalendarEventAction?
  isExpandable?: boolean
  isEditAble?: boolean
  user?: any
  updateMeetingAction
  deleteGoogleCalendarEventAction
  cancelOutLookMeetingAction
}

const UpcomingMeetingCard: FC<IUpcomingMeetingCard> = ({
  event,
  timeMin = 0,
  timeMax = 0,
  cancelUserCalendarEventAction,
  isEditAble,
  user,
  updateMeetingAction,
}) => {
  const [openPreviewModal, setOpenPreviewModal] = useState(false)
  const previewModalHandler = () => setOpenPreviewModal(!openPreviewModal)

  const isGoTackleEvent = () => {
    return event.tackleId
  }

  return (
    <EventWrapper
      className={`close border-[1px] border-primary-outline rounded-[10px] bg-secondary mt-3 mb-[14px] xs:px-[18px] xs:py-[24px] sm:pl-[34px]  sm:pr-[35px] sm:pt-[23px] sm:pb-[20px]
        ${isEditAble ? 'cursor-pointer  hover:bg-cream-light' : ''}
        `}
    >
      <div className="flex gap-[1.5rem] withoutExpendWrap max-h-[70px] min-h-[70px] items-center">
        <div className="flex-shrink-0 w-24">
          {isGoTackleEvent() && (
            <img
              src={tackleIcon}
              alt="GoTackle icon"
              className="xs:max-w-[40px] xs:max-h-[40px] sm:max-w-[45px] sm:max-h-[45px]"
            />
          )}
          <label className="text-lg text-primary-text font-primary leading-7">
            {moment(event.start).format('h:mm A')}
          </label>
        </div>
        <div className="w-full truncate">
          <div className="flex items-center justify-between gap-2 mr-1">
            <div className="flex flex-col w-full truncate">
              <div className="w-full truncate inline-block  capitalize leading-7 text-lg text-primary-text font-primary font-medium ">
                {event.title}
              </div>
              {
                <p className="text-base pt-[12px]  text-primary-text font-primary leading-6 capitalize">
                  {user?.id === event?.inviteeId ? event?.participantName : event?.organizerName}
                </p>
              }

              <Button
                label="View Details"
                variant="text"
                onClick={() => previewModalHandler()}
                className="w-min"
              />
            </div>
          </div>
        </div>
      </div>
    </EventWrapper>
  )
}

export default UpcomingMeetingCard
